import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@material-ui/core';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ order, orderBy, onRequestSort }) => {
  return (
    <TableHead>
      <TableRow>
        <TableCell sortDirection={orderBy === 'message' ? order : false}>
          <TableSortLabel
            active={orderBy === 'message'}
            direction={order}
            onClick={() => {
              onRequestSort('message');
            }}
          >
            お知らせ
          </TableSortLabel>
        </TableCell>
        <TableCell />
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
